<template>
  <div>
    <LoaderCircle :size="24" :color="'var(--circle-loader)'"/>
  </div>
</template>

<script setup>
  import { LoaderCircle } from '@/Groups/Notifications/private/imports/externalTemplates';
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>